<template>
  <div id="app">

		<nav-mobile></nav-mobile>

		<app-header
    :app_label="instance_data.label"
    ></app-header>
		
		<transition
    name="" 
    mode="out-in"
    enter-active-class="animated fadeIn faster" 
    leave-active-class="animated fadeOut faster"
    >

  		<keep-alive>
  			<router-view></router-view>
  		</keep-alive>

		</transition>

		<app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from '@/features/header.vue'
import AppFooter from '@/features/footer.vue'
import NavMobile from '@/features/navigation/nav_mobile.vue';

export default {
  name: 'app',
  data () {
    return {
      
    }
  },
  created() {
  	// GET INSTANCE DATA FOR APP
  	this.$root.store.instances.get_client_instance_data(
      this.$root.store.get_current_clientid()
    );

    // RETRIEVE GENERAL LAST MODIFIED
    this.$root.store.storage.retrieve_general_last_modified();
  },
  mounted() {
    // OUTPUT CMG GA SCRIPTS
    this.outputGaScriptsForCMG();

    // CHECK FOR LOGGED IN USER
    this.$root.store.session.check_stored_login();
  },
  computed: {
  	instanceid: function() {
  		return this.$root.store.instances.state.instanceid;
  	},
  	instance_period: function() {
  		return this.$root.store.instances.get_current_active_instance_period();
  	},
    instance_data: function() {
      return this.$root.store.instances.state.instance_data;
    }
  },
  methods: {
  	get_master_contest_list: function() {
  		// GET ALL CONTESTS FOR APP ON LOAD.
  		// THIS WILL IMPROVE PERFORMANCE OVERALL COMPARED
  		// TO PULLING IN SMALLER CHUNKS LATER.
  		this.$root.store.contests.get_master_contest_list(
  			this.instanceid
  		);
  	},

    outputGaScriptsForCMG: function() {
      let gaScript = document.createElement('script');
      gaScript.src = '//assets.adobedtm.com/20d5deb47c9e7fe47a9f969db01578a739d7179d/satelliteLib-3bdb96ce8c62153cdc81a8a72fc964fe2ffa1652.js';
      document.getElementsByTagName('head')[0].appendChild(gaScript);

      // RUN
      setTimeout(function() {
        _satellite.pageBottom();
      },1000);
      
    }
  },
  watch: {
  	instanceid: function(new_val, old_val) {
  		let vm = this;

  		if(new_val > 0) {
  			vm.get_master_contest_list();
  		}
  	}
  },
  components: {
    AppHeader,
    AppFooter,
    NavMobile
  }
}
</script>

<style lang="scss">
@import '../node_modules/bootstrap/dist/css/bootstrap-reboot.css';
@import '../node_modules/bootstrap/dist/css/bootstrap.css';
@import '../node_modules/@fortawesome/fontawesome-free/css/fontawesome.css';
@import '../node_modules/animate.css/animate.css';

html, body {
  height: 100%;
}

body {
  margin: 0;
}

#app {

  max-width: 100%;
  min-height: 100%;
  overflow: hidden;
  position: relative;
  padding-bottom: 12rem;

  .section_title {
    text-align: center;
    padding: 0.25em 0;
    /*margin-bottom: 0.7em;*/
  }

}
</style>



// WEBPACK FOOTER //
// src/App.vue